import { useLang } from "@/i18n/LanguageContext";
import { Reveal, Eyebrow } from "@/components/Reveal";
import Seo from "@/components/Seo";

export default function Privacy() {
  const { t, lang } = useLang();
  return (
    <div data-testid="privacy-page" key={lang} className="pt-16 sm:pt-20">
      <Seo title={t.seo.privacy.title} description={t.seo.privacy.desc} />
      <div className="max-w-3xl mx-auto px-4 sm:px-8 py-20 sm:py-28">
        <Reveal>
          <Eyebrow>Sobe Bevanda — Međugorje</Eyebrow>
          <h1 className="font-serif-display text-4xl sm:text-5xl text-[#1F2421]">{t.privacy.title}</h1>
          <p className="text-base sm:text-lg text-[#4A504B] leading-relaxed mt-8">{t.privacy.text}</p>
        </Reveal>
      </div>
    </div>
  );
}
